import React from 'react';
import { Badge } from './Badge';
import { 
  getStatusConfig, 
  contractStatusMap, 
  contractTypeMap,
  packageTypeMap,
  projectStatusMap, 
  woStatusMap, 
  approvalStatusMap, 
  accountStatusMap,
  zoneStatusMap 
} from '@/utils/status';
import { roleConfigMap } from '@/utils/role';

export interface StatusBadgeProps {
  status: string | any;
  type?: 'contract' | 'contract-type' | 'package' | 'project' | 'wo' | 'approval' | 'account' | 'zone' | 'role' | 'default';
  className?: string;
  showIcon?: boolean;
  size?: 'sm' | 'md';
  label?: string;
  variant?: 'primary' | 'danger' | 'success' | 'info' | 'default' | 'warning' | 'neutral';
}

const mapRegistry = {
  contract: contractStatusMap,
  'contract-type': contractTypeMap,
  package: packageTypeMap,
  project: projectStatusMap,
  wo: woStatusMap,
  approval: approvalStatusMap,
  account: accountStatusMap,
  zone: zoneStatusMap,
  role: roleConfigMap,
  default: woStatusMap,
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ 
  status, 
  type,
  className,
  showIcon = true,
  size = 'md',
  label,
  variant
}) => {
  if (label) {
    return (
      <Badge
        variant={variant === 'neutral' ? 'default' : variant}
        className={`flex items-center gap-1.5 w-fit ${size === 'sm' ? 'px-2 py-0' : ''} ${className}`}
      >
        {label}
      </Badge>
    );
  }

  // If status is an object (pre-configured)
  if (typeof status === 'object' && status !== null && status.label) {
    const s = status as any;
    return (
      <Badge 
        variant={s.variant === 'neutral' ? 'default' : s.variant} 
        className={`flex items-center gap-1.5 w-fit ${size === 'sm' ? 'px-2 py-0' : ''} ${className}`}
      >
        {showIcon && s.icon && <i className={s.icon} />}
        {s.label}
      </Badge>
    );
  }

  // Use map if type is provided
  const config = type && mapRegistry[type] 
    ? getStatusConfig(status, mapRegistry[type])
    : getStatusConfig(status);

  return (
    <Badge 
      variant={config.variant as any} 
      className={`flex items-center gap-1.5 w-fit ${size === 'sm' ? 'px-2 py-0' : ''} ${className}`}
    >
      {showIcon && <i className={config.icon} />}
      {config.label}
    </Badge>
  );
};
